export default __webpack_public_path__ + "1f5d59d8afd329f3aaab502bc4914b19.webp";